import { createColumnHelper } from "@tanstack/react-table";
import { useSelector } from "react-redux";
import DashboardTable from "./DashboardTable";

const columnHelper = createColumnHelper();

function UsersTable() {
  const { dashboardData, dashboardLoading, dashboardError } = useSelector(
    (state) => state.dashboard
  );

  const users = dashboardData?.data?.users;

  const usersData = users?.byRole || [];

  const usersColumns = [
    columnHelper.accessor("roleName", {
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">ROLE</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
    columnHelper.accessor("count", {
      header: () => (
        <p className="text-sm font-bold text-gray-600 dark:text-white">COUNT</p>
      ),
      cell: (info) => (
        <p className="text-sm font-bold text-navy-700 dark:text-white">
          {info.getValue()}
        </p>
      ),
    }),
  ];

  return (
    <DashboardTable
      title="Users Table"
      columns={usersColumns}
      data={usersData}
      loading={dashboardLoading}
      error={dashboardError}
    />
  );
}

export default UsersTable;
